// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .menu-section[data-v-7275545a]{cursor:pointer}#app label[data-v-7275545a]{font-weight:400;line-height:2.2em}#app .text-bold[data-v-7275545a]{font-weight:700}#app img.ring[data-v-7275545a]{display:block;width:5em;height:5em;border-radius:5em;border:.1rem solid #777;margin:auto;margin-bottom:.5em}#app .input-group input[data-v-7275545a],#app .input-group select[data-v-7275545a]{height:2.5em}", ""]);
// Exports
module.exports = exports;
